import React, { useMemo } from 'react'
import { I18nHtmlProps } from './types'
import { TrustedHtml } from '../trusted_html'

export const I18nHtml = ({ i18nKey, options, ...props }: I18nHtmlProps) => {
  const value = useMemo(() => i18n.t(i18nKey, options), [i18nKey, options])
  return <TrustedHtml value={value} {...props} />
}
